import React from 'react';
import { View, Text, StyleSheet, ScrollView, Pressable } from 'react-native';
import Colors from '../../constants/Colors';
import CS from '../../constants/Styles';
import { BackgroundGradient, Loader, TextInputContainer } from '../../components';
import * as rtApi from '../../components/Api';
import { formatAmount, formatCurrency } from '../../utils/Functions';
import UserState from '../../src/contexts/UserState';
import { FontAwesome5 } from '@expo/vector-icons';
import SelectBox from 'react-native-multi-selectbox';
import { useLinkTo } from '@react-navigation/native';
import { Dimensions } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

const FeeCalculatorScreen = ({ navigation }) => {
  const [user, setUser] = React.useContext(UserState);
  const [loading, setLoading] = React.useState(false);
  const [total, setTotal] = React.useState('');
  const [whoPays, setWhoPays] = React.useState('Both');
  const [fee, setFee] = React.useState(0);
  const [tax, setTax] = React.useState(0);
  const [feeTotal, setFeeTotal] = React.useState(0);

  const textInput = React.useRef(null);
  const linkTo = useLinkTo();
  const windowWidth = Dimensions.get('window').width;
  const insets = useSafeAreaInsets();
  console.log('windowWidth: ', windowWidth);

  React.useEffect(() => {
    textInput.current.focus();
    
    return () => rtApi.cancel();
  }, []);
  
  const whoPaysOptions = [
    {
      item: user.isContractor ? 'My Customer Pays the Fee' : 'My Contractor Pays the Fee',
      id: 1,
    },
    {
      item: 'We Split the Fee 50/50',
      id: 2,
    },
    {
      item: 'I Pay the Fee',
      id: 3,
    },
  ]
  const [whoPaysSelect, setWhoPaysSelect] = React.useState({...whoPaysOptions[1]});
  const selectWhoPays = (w) => {
    let localWhoPays = '';
    setWhoPaysSelect(w);
    switch (w.id){
      case 1:
        localWhoPays = user.isContractor ? 'Homeowner' : 'Contractor';
        break;
      case 2:
        localWhoPays = 'Both';
        break;
      case 3:
        localWhoPays = user.isContractor ? 'Contractor' : 'Homeowner';
        break;
    }
    setWhoPays(localWhoPays);
    getFees(total, localWhoPays);
  }

  const onChangeTotal = (val) => {
    let formatted = formatAmount(val);
    console.log('onChangeTotal: ', val, formatted);
    setTotal(formatted);
    getFees(formatted, whoPays);
  }

  const getFees = (amount, who) => {
    console.log('getFees: ', amount, who);
    //$amount, $payor ('both','contractor','homeowner'), $quickbooks_id
    rtApi.cancel();
    rtApi.get(`money/calculator?amount=${formatAmount(amount)}&payor=${who}`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('getFees: ', data, tax);
      const fee = getFee(who, data);
      setFee(fee);
      // setTax(data.tax);
      setFeeTotal(fee + tax);
      // setFeeTotal(data.total);
    });
  }

  const getFee = (who, data) => {
    console.log('getFee: ', user.isContractor, who);
    let fee = 0;
    if((user.isContractor && who !== 'Homeowner') || (!user.isContractor && who !== 'Contractor')){
      fee = (who === 'Contractor') ? data.fee_contractor : data.fee_homeowner;
    }
    return fee;
  }
  // const toggleWhoPays = (whoPays) => {
  //   setWhoPays(whoPays);
  //   getFees(total, whoPays);
  // }
  const goBack = () => {
    if(navigation.canGoBack()){
      navigation.goBack();
    }else{
      linkTo('/projects');
    }
  }

  const onBlurTotal = (total) => {
    let formatted = formatCurrency(total);
    setTotal(formatted);
  }
  const onFocusTotal = (total) => {
    let formatted = formatAmount(total);
    setTotal(formatted);
  }

  const headerTextSize = () => {
    return {
      fontSize: windowWidth <= 375 ? 16 : 18,
    }
  }

  return (
    <View style={CS.safe}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <ScrollView contentContainerStyle={[CS.scrollViewContentContainerStyle, { paddingTop: insets.top, paddingBottom: insets.bottom, flexGrow: 1 }]} style={[CS.scrollViewStyle, { paddingHorizontal: 10 }]}>
        <View style={CS.rowContainer}>
          <Pressable onPress={goBack} hitSlop={10} style={({ pressed }) => [{ opacity: pressed ? 0.5 : 1.0 }]}>
            <FontAwesome5 name="arrow-left" size={24} color="white" />
          </Pressable>
          <Text style={[CS.smallTitle, CS.lightText, { marginLeft: 20 }]}>Total Project Cost</Text>
        </View>
        <TextInputContainer
          placeholder={formatCurrency(0)}
          onChangeText={(t) => onChangeTotal(t)}
          inputRef={textInput}
          // isInvalid={isInvalid.total}
          keyboardType='numeric'
          onBlur={() => onBlurTotal(total)}
          onFocus={() => onFocusTotal(total)}
          value={total}
          // editable={editing}
          // inputContainerStyle={{ backgroundColor: 'yellow' }}
          //height: 64,
          inputStyle={{ fontSize: 58 }}
          returnKeyType='done'
          autoFocus={true}
        />
        {/* dropdown */}
        <SelectBox
          label=""
          options={whoPaysOptions}
          value={whoPaysSelect}
          onChange={selectWhoPays}
          hideInputFilter={true}
          arrowIconColor={Colors.lightGrey}
          labelStyle={{ display: 'none', }}
          optionsLabelStyle={{ color: Colors.lightText, padding: 8, backgroundColor: Colors.textInputBackground }}
          selectedItemStyle={{ color: Colors.lightText }}
          containerStyle={{ borderWidth: 1, borderRadius: 10, backgroundColor: Colors.textInputBackground, padding: 8, height: 44, borderColor: Colors.lightBlue, alignItems: 'center' }}
          optionContainerStyle={{ borderWidth: 1, borderColor: Colors.lightBlue, padding: 0, paddingVertical: 0, paddingRight: 0, backgroundColor: Colors.textInputBackground, borderRadius: 0, width: '96%', marginLeft: '2%', flexDirection: 'column', alignItems: 'stretch' }}
          listEmptyLabelStyle={{ color: Colors.lightText, }}
        />
        {/* buttons */}
        {/* <View style={[CS.rowContainer, styles.tabButtonContainer]}>
          <TouchableOpacity activeOpacity={0.6} onPress={() => toggleWhoPays('contractor')} style={[CS.tabButton, CS.tabButtonLeft, (whoPays === 'contractor' && CS.tabButtonActive)]}>
            <Text style={[CS.smallText, CS.boldText, CS.lightText, (whoPays === 'contractor' && CS.darkText)]}>Contractor</Text>
          </TouchableOpacity>
          <TouchableOpacity activeOpacity={0.6} onPress={() => toggleWhoPays('both')} style={[CS.tabButton, CS.tabButtonCenter, (whoPays === 'both' && CS.tabButtonActive)]}>
            <Text style={[CS.smallText, CS.boldText, CS.lightText, (whoPays === 'both' && CS.darkText)]}>50/50</Text>
          </TouchableOpacity>
          <TouchableOpacity activeOpacity={0.6} onPress={() => toggleWhoPays('homeowner')} style={[CS.tabButton, CS.tabButtonRight, (whoPays === 'homeowner' && CS.tabButtonActive)]}>
            <Text style={[CS.smallText, CS.boldText, CS.lightText, (whoPays === 'homeowner' && CS.darkText)]}>Homeowner</Text>
          </TouchableOpacity>
        </View> */}
        {/* fees */}
        {/* <View style={[CS.rowContainer, styles.feeRow, { marginTop: 20 }]}>
          <Text style={[CS.smallText, CS.lightBlueText, CS.rightText, styles.feeText]}>Protection Fee</Text>
          <Text style={[CS.smallText, CS.lightBlueText, CS.rightText, amountStyle()]}>{formatCurrency(fee)}</Text>
        </View>
        <View style={[CS.rowContainer, styles.feeRow]}>
          <Text style={[CS.smallText, CS.lightBlueText, CS.rightText, styles.feeText]}>Tax</Text>
          <Text style={[CS.smallText, CS.lightBlueText, CS.rightText, amountStyle()]}>{formatCurrency(tax)}</Text>
        </View>
        <View style={styles.separator}></View> */}
        <View style={[CS.rowContainer, styles.feeRow, { marginTop: 20 }]}>
          <Text style={[CS.smallText, CS.boldText, CS.lightText, CS.rightText, styles.feeText]}>Your Total Cost</Text>
          <Text style={[CS.smallText, CS.boldText, CS.lightText, CS.rightText]}>{formatCurrency(feeTotal)}</Text>
        </View>
        {/* explanation */}
        <Text style={[CS.smallText, CS.lightText, CS.boldText, { marginTop: 20, marginBottom: 10 }]}>Protection Fee Explained</Text>
        <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 20 }]}>Our fees are regressive; the larger your project, the lower the rate becomes.</Text>
        <View style={styles.separator}></View>
        <View style={[CS.rowContainer, styles.feeRow]}>
          <Text style={[CS.smallText, CS.boldText, CS.lightText, styles.col1, headerTextSize()]}>Project Value</Text>
          <Text style={[CS.smallText, CS.boldText, CS.lightText, styles.col2, headerTextSize()]}>Homeowner</Text>
          <Text style={[CS.smallText, CS.boldText, CS.lightText, styles.col3, headerTextSize()]}>Contractor</Text>
          <Text style={[CS.smallText, CS.boldText, CS.lightText, styles.col4, headerTextSize()]}>Total Fees</Text>
        </View>
        <View style={styles.separator}></View>
        <View style={[CS.rowContainer, styles.feeRow]}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.col1]}>First $5,000</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.col2]}>3.25%</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.col3]}>3.25%</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.col4]}>6.5%</Text>
        </View>
        <View style={[CS.rowContainer, styles.feeRow]}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.col1]}>Next $20,000</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.col2]}>1.49%</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.col3]}>1.49%</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.col4]}>2.98%</Text>
        </View>
        <View style={[CS.rowContainer, styles.feeRow]}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.col1]}>Next $50,000</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.col2]}>1.19%</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.col3]}>1.19%</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.col4]}>2.38%</Text>
        </View>
        <View style={[CS.rowContainer, styles.feeRow]}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.col1]}>Next $125,000</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.col2]}>0.99%</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.col3]}>0.99%</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.col4]}>1.98%</Text>
        </View>
        <View style={[CS.rowContainer, styles.feeRow]}>
          <Text style={[CS.smallText, CS.lightBlueText, styles.col1]}>After $200,000</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.col2]}>0.49%</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.col3]}>0.49%</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.col4]}>0.98%</Text>
        </View>
        <View style={styles.separator}></View>
        {/* <Text style={[CS.smallText, CS.lightBlueText, { marginTop: 20 }]}>Given that our service equally benefits homeowners and contractors, the fees are split 50/50 by default, and thus the default fee is 3.25% - half of the entire 6.5% fee. However the balance can be changed. Contractors may choose to cover 100% of the fee - making our service free to their customers. Others may not be willing to pay any of the fee, so the fee may be as high as 6.25% for their customer.</Text> */}
      <Text style={[CS.smallText, CS.lightBlueText, { marginTop: 20 }]}>The Renovation Trust Protection fee is split 50/50 by default between the homeowner and the contractor as both parties are protected equally.</Text>
      <Text style={[CS.smallText, CS.lightBlueText, { marginTop: 10 }]}>The contractor in their account can change this to whereby they pay the entire fee making the service free for the homeowner. The contractor can also refuse to pay any of the Renovation Trust Fees and can force the homeowner to pay all the fees.</Text>
      <Text style={[CS.smallText, CS.lightBlueText, { marginTop: 10 }]}>If a contractor is pushing all the fees onto the homeowner, the homeowner can agree, negotiate or find another contractor.</Text>
        {!user.isContractor &&
          <Text style={[CS.smallText, CS.lightBlueText, { marginVertical: 10 }]}>Speak to your contractor to determine your actual fee.</Text>
        }
        {user.isContractor &&
          <Text style={[CS.smallText, CS.lightBlueText, { marginVertical: 10 }]}>As a contractor, you can decide who pays the fee on a project-by-project basis.</Text>
        }
      </ScrollView>
    </View>
  );

}

const styles = StyleSheet.create({
  tabButtonContainer: {
    marginBottom: 10,
  },
  separator: {
    width: '100%',
    borderTopWidth: 1,
    borderColor: Colors.lightBlue2,
    marginVertical: 5,
  },
  feeRow: {
    width: '100%',
    marginVertical: 5
  },
  feeText: {
    flex: 1,
    marginRight: 20,
  },
  col1: {
    width: '34%',
    textAlign: 'left',
    // flex: 1,
  },
  col2: {
    width: '22%',
    textAlign: 'center',
    // flex: 1,
  },
  col3: {
    width: '22%',
    textAlign: 'center',
    // flex: 1,
  },
  col4: {
    width: '22%',
    textAlign: 'center',
    // flex: 1,
  },
});

export default FeeCalculatorScreen;